import React from 'react';
import { connect } from 'react-redux';
import { Text, Button, Theme, i18n, tokens } from '@simplybenefits/sb-ui-library';
import store from "../../../redux/store";

/**
 *
 * @param {*} param0
 */
const ClaimError = ({ fixableClaimErrors, continueAnyway, onBack }) => {

    const styles = {
        container: {
            flex: 1,
            display: 'flex',
            flexDirection: 'column'
        },
        main: {
            display: 'flex',
            flex: 1,
            overflow: 'auto',
            flexDirection: 'column',
            marginBottom: 20,
            justifyContent: 'center',
            alignItems: 'center',
            paddingLeft: 20,
            paddingRight: 20
        },
        btnContainer: {
            display: 'flex',
            flexDirection: 'row'
        },
        btn: {
            backgroundColor: Theme.colors.surface,
            height: 60,
            borderRadius: 0
        }
    };
    
    return (
        <div style={ styles.container }>
            <div style={styles.main}>
                <Text
                    color={Theme.colors.surface}
                    display="block"
                    largest
                    bold
                    customStyle={{
                        fontSize: '35px',
                        textAlign: 'center'
                    }}
                >
                    { i18n.t(tokens.labels.claims.confirmContinue) }
                </Text>

                {
                    fixableClaimErrors.map((error, i) => (
                        <Text
                            color={Theme.colors.surface}
                            display="block"
                            mediumLarge
                            margin="20px 10px 0 10px"
                            align="center"
                            key={i}
                        >
                            { error }
                        </Text>
                    ))
                }

                <Text
                    color={Theme.colors.surface}
                    display="block"
                    mediumLarge
                    margin="30px 10px 0 10px"
                    align="center"
                >
                    { i18n.t(tokens.labels.claims.quickReimbursementNote) }
                </Text>
            </div>

            <div style={ styles.btnContainer }>
                <Button
                    onClick={onBack}
                    customStyle={ styles.btn }
                    fullWidth
                    color={"white"}
                >
                    <Text
                        medium
                        bold
                        color={store.getState().whitelabel.primaryColor || Theme.colors.skyBlue}
                        customStyle={{ letterSpacing: "0.02857em" }}
                    >
                        { i18n.t(tokens.buttons.editSubmission) }
                    </Text>
                </Button>

                <Button
                    onClick={continueAnyway}
                    customStyle={ styles.btn }
                    fullWidth
                    color={"white"}
                >
                    <Text
                        medium
                        bold
                        color={ Theme.colors.red }
                        customStyle={{ letterSpacing: "0.02857em" }}
                    >
                        { i18n.t(tokens.buttons.continueAnyway) }
                    </Text>
                </Button>
            </div>
        </div>
    );
};

export default connect()(ClaimError);